import { StoreState } from "../types";
import { CreateInvestmentManageable, InvestmentManageable } from "./types";

export const storeCurrentInvestmentReducer = (
  state: StoreState,
  currentInvestment: InvestmentManageable
) => {
  localStorage.setItem(
    "currentInvestment",
    JSON.stringify(currentInvestment)
  );

  return {
    ...state,
    currentInvestment,
  };
};

export const storeCurrentCreatedInvestmentReducer = (
  state: StoreState,
  currentCreatedInvestment: CreateInvestmentManageable
) => {
  localStorage.setItem(
    "currentCreatedInvestment",
    JSON.stringify(currentCreatedInvestment)
  );

  return {
    ...state,
    currentCreatedInvestment,
  };
};

export const storeInvestmentsReducer = (
  state: StoreState,
  investments: Array<InvestmentManageable>
) => {
  localStorage.setItem(
    "investments",
    JSON.stringify(investments)
  );

  return {
    ...state,
    investments,
  };
};

export const storeUpdateInvestmentReducer = (
  state: StoreState,
  updatedInvestment: InvestmentManageable
) => {
  let investments = [...state.investments];
  const index = investments.findIndex((investment: InvestmentManageable) => investment.id === updatedInvestment.id);
  investments[index] = updatedInvestment;

  localStorage.setItem(
    "investments",
    JSON.stringify(investments)
  );

  return {
    ...state,
    investments,
  };
};
